import { render, staticRenderFns } from "./WorkQueueList.vue?vue&type=template&id=6272ea1c&"
import script from "./WorkQueueList.vue?vue&type=script&lang=js&"
export * from "./WorkQueueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports